"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStorage = void 0;
const common_utils_1 = require("@fluidframework/common-utils");
const runtime_utils_1 = require("@fluidframework/runtime-utils");
/**
 * Mock implementation of IChannelStorageService based on ITree input.
 */
class MockStorage {
    constructor(tree) {
        this.tree = tree;
    }
    static createFromSummary(summaryTree) {
        const tree = (0, runtime_utils_1.convertSummaryTreeToITree)(summaryTree);
        return new MockStorage(tree);
    }
    static readBlobCore(tree, paths) {
        if (tree) {
            for (const entry of tree.entries) {
                if (entry.path === paths[0]) {
                    if (entry.type === "Blob") {
                        // eslint-disable-next-line prefer-rest-params
                        (0, common_utils_1.assert)(paths.length === 1, JSON.stringify(Object.assign({}, arguments)));
                        return entry.value;
                    }
                    if (entry.type === "Tree") {
                        return MockStorage.readBlobCore(entry.value, paths.slice(1));
                    }
                    return undefined;
                }
            }
            return undefined;
        }
    }
    async readBlob(path) {
        const blob = MockStorage.readBlobCore(this.tree, path.split("/"));
        (0, common_utils_1.assert)(blob !== undefined, `Blob does not exist: ${path}`);
        return (0, common_utils_1.stringToBuffer)(blob.contents, blob.encoding);
    }
    async contains(path) {
        return MockStorage.readBlobCore(this.tree, path.split("/")) !== undefined;
    }
    async list(path) {
        return (0, runtime_utils_1.listBlobsAtTreePath)(this.tree, path);
    }
}
exports.MockStorage = MockStorage;
//# sourceMappingURL=mockStorage.js.map